import React, { useEffect, useState } from "react";
import edit_1 from "../../../images/edit_1.png";
import del_1 from "../../../images/del_1.png";
import FBChart1 from "./FBchart1";
import { useLanguage } from "../../../Providers/LanguageContext";
import GanttChart from "../../TaskManager/GanttChart";
import EventsCalender from "../../TaskManager/EventsCalender";
import toast from "react-hot-toast";
import ViewCapitalOption from "../../InvestmentManager/UserInvestor/ViewCapitalOption";
import { useDispatch } from "react-redux";
import {
  reset_balance_dashboard,
  reset_current_total_bar,
  reset_current_total_bar2,
  reset_current_total_line,
  reset_current_vs_actual_budget_bar,
  reset_current_vs_actual_budget_line,
  reset_expense_bar_chart,
  reset_expense_line_chart,
  reset_expense_per_bar_graph,
  reset_expense_per_line_graph,
  reset_kanban_data,
  reset_open_acc_receive,
  reset_profit_line_chart,
  reset_sales_line_chart,
  reset_task_at_risk,
  reset_task_complete_status,
  reset_task_deviation_analysis,
  reset_tax_line,
  reset_tax_pie,
  reset_transaction_dashboard,
  set_balance_dashboard,
  set_current_total_bar,
  set_current_total_line,
  set_current_vs_actual_budget_bar,
  set_current_vs_actual_budget_line,
  set_expense_bar_chart,
  set_expense_line_chart,
  set_expense_per_bar_graph,
  set_expense_per_line_graph,
  set_open_acc_receive,
  set_profit_line_chart,
  set_sales_line_chart,
  set_task_at_risk,
  set_task_complete_status,
  set_task_deviation_analysis,
  set_tax_line,
  set_tax_pie,
  set_transaction_dashboard,
  toggle_Kanban_data,
} from "../../../redux/reducers/favDashboardSlice";
import RiskManagement from "../../TaskManager/RiskManagement";
import DashboardManager from "../dashboard/DashboardManager";
import HttpClient from "../../../utils/HttpClient";
import { useUserData } from "../../../Providers/UserWrapper";
import Loader from "../../../Loader/Loader";
import { useSelector } from "react-redux";

const GrandChart = () => {
  const { taskCompletionStatus, taskAtRisk, taskDeviationAnalysis } =
    useSelector((state) => state?.favDashboard);
  const { setIsLoading } = useUserData();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { language } = useLanguage();

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const [widgetsOne, setWidgetsOne] = useState([]);
  const [selectedWidgetOne, setSelectedWidgetOne] = useState(null);

  const fetchWidgetOneData = async () => {
    try {
      setIsLoading(true);

      const res = await HttpClient.requestData("dashboard", "GET");
      console.log("console", res);
      if (res && res?.widgets && Object.keys(res?.widgets)?.length > 0) {
        //   console.log("fav init res: ", res);
        setWidgetsOne(res?.widgets?.one || []);
      } else {
        console.log("error", res);
        setWidgetsOne([]);
        //   toast.error("widget one data is not able to load ....");
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!!!");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchWidgetOneData();
  }, []);

  useEffect(() => {
    if (widgetsOne) {
      setSelectedWidgetOne(widgetsOne?.find((item) => item?.visible) || null);
    }
  }, [widgetsOne]);

  const handleSelectWidget = (widget) => {
    setSelectedWidgetOne(widget);
    toast.success("Widget has been changed successfully");
    closeModal();
  };

  // useEffect(() => {
  //     if (selectedWidgetOne && selectedWidgetOne?.name === "Kanban Board Analytics") {
  //         dispatch(toggle_Kanban_data());
  //         dispatch(reset_open_acc_receive());
  //     }
  //     if (selectedWidgetOne && selectedWidgetOne?.name === "Open Account Receivable") {
  //         dispatch(reset_kanban_data());
  //         dispatch(set_open_acc_receive());
  //     }
  //     if (selectedWidgetOne && selectedWidgetOne?.name === "profit vs expense (line graph)") {
  //         dispatch(set_expense_per_line_graph());
  //         dispatch(reset_kanban_data());
  //         dispatch(reset_open_acc_receive());
  //         dispatch(reset_expense_per_bar_graph());
  //     }
  //     if (selectedWidgetOne && selectedWidgetOne?.name === "profit vs expense (pie graph)") {
  //         dispatch(set_expense_per_bar_graph());
  //         dispatch(reset_kanban_data());
  //         dispatch(reset_open_acc_receive());
  //         dispatch(reset_expense_per_line_graph());
  //     }
  //     if (selectedWidgetOne && selectedWidgetOne?.name === "Expense Bar Chart") {
  //         dispatch(set_expense_bar_chart());
  //         dispatch(reset_kanban_data());
  //         dispatch(reset_open_acc_receive());
  //         dispatch(reset_expense_per_line_graph());
  //         dispatch(reset_expense_per_bar_graph());
  //         dispatch(reset_profit_line_chart());
  //         dispatch(reset_sales_line_chart());
  //         dispatch(reset_expense_line_chart());
  //     }
  //     if (selectedWidgetOne && selectedWidgetOne?.name === "Expense Line Chart") {
  //         dispatch(set_expense_line_chart());
  //         dispatch(reset_kanban_data());
  //         dispatch(reset_open_acc_receive());
  //         dispatch(reset_expense_per_line_graph());
  //         dispatch(reset_expense_per_bar_graph());
  //         dispatch(reset_profit_line_chart());
  //         dispatch(reset_sales_line_chart());
  //         dispatch(reset_expense_bar_chart());
  //     }
  //     if (selectedWidgetOne && selectedWidgetOne?.name === "Profit Line Chart") {
  //         dispatch(set_profit_line_chart());
  //         dispatch(reset_kanban_data());
  //         dispatch(reset_open_acc_receive());
  //         dispatch(reset_expense_per_line_graph());
  //         dispatch(reset_expense_per_bar_graph());
  //         dispatch(reset_sales_line_chart());
  //         dispatch(reset_expense_bar_chart());
  //         dispatch(reset_expense_line_chart());
  //     }
  //     if (selectedWidgetOne && selectedWidgetOne?.name === "Sales Line Chart") {
  //         dispatch(set_sales_line_chart());
  //         dispatch(reset_kanban_data());
  //         dispatch(reset_open_acc_receive());
  //         dispatch(reset_expense_per_line_graph());
  //         dispatch(reset_expense_per_bar_graph());
  //         dispatch(reset_profit_line_chart());
  //         dispatch(reset_expense_bar_chart());
  //         dispatch(reset_expense_line_chart());
  //         dispatch(reset_profit_line_chart());
  //     }

  // }, [dispatch, selectedWidgetOne]);

  useEffect(() => {
    if (selectedWidgetOne) {
      // Reset all first
      dispatch(reset_kanban_data());
      dispatch(reset_open_acc_receive());
      dispatch(reset_expense_per_line_graph());
      dispatch(reset_expense_per_bar_graph());
      dispatch(reset_expense_bar_chart());
      dispatch(reset_expense_line_chart());
      dispatch(reset_profit_line_chart());
      dispatch(reset_sales_line_chart());
      dispatch(reset_task_complete_status());
      dispatch(reset_task_deviation_analysis());
      dispatch(reset_task_at_risk());
      dispatch(reset_current_total_bar());
      dispatch(reset_current_total_line());
      dispatch(reset_current_vs_actual_budget_bar());
      dispatch(reset_current_vs_actual_budget_line());
      dispatch(reset_transaction_dashboard());
      dispatch(reset_balance_dashboard());
      dispatch(reset_tax_line());
      dispatch(reset_tax_pie());

      // Set based on selected widget
      switch (selectedWidgetOne?.name) {
        case "Kanban Board Analytics":
          dispatch(toggle_Kanban_data());
          break;
        case "Open Account Receivable":
          dispatch(set_open_acc_receive());
          break;
        case "profit vs expense (line graph)":
          dispatch(set_expense_per_line_graph());
          break;
        case "profit vs expense (pie graph)":
          dispatch(set_expense_per_bar_graph());
          break;
        case "Expense Bar Chart":
          dispatch(set_expense_bar_chart());
          break;
        case "Expense Line Chart":
          dispatch(set_expense_line_chart());
          break;
        case "Profit Line Chart":
          dispatch(set_profit_line_chart());
          break;
        case "Sales Line Chart":
          dispatch(set_sales_line_chart());
          break;

        case "Task Completion Status":
          dispatch(set_task_complete_status());
          break;
        case "Task Deviation Analysis":
          dispatch(set_task_deviation_analysis());
          break;
        case "Tasks At-Risk":
          dispatch(set_task_at_risk());
          break;

        case "current total (bar graph)":
          dispatch(set_current_total_bar());
          break;
        case "current total (line graph)":
          dispatch(set_current_total_line());
          break;
        case "current actual vs budget (bar graph)":
          dispatch(set_current_vs_actual_budget_bar());
          break;
        case "current actual vs budget (line graph)":
          dispatch(set_current_vs_actual_budget_line());
          break;
        case "Balance dashboard":
          dispatch(set_balance_dashboard());
          break;
        case "Transaction dashboard":
          dispatch(set_transaction_dashboard());
          break;
        case "Tax deductible (pie graph)":
          dispatch(set_tax_pie());
          break;
        case "Tax deductible (line graph)":
          dispatch(set_tax_line());
          break;
        default:
          break;
      }
    }
  }, [dispatch, selectedWidgetOne]);

  const handleAddWidget = async (widget) => {
    console.log("add widget", widget);
    try {
      const res = await HttpClient.requestData("dashboard", "PUT", {
        widgetId: widget?.widgetId,
      });
      if (res?.message !== "Widget not found in dashboard") {
        toast.success("Widget one has been updated successfully");
        fetchWidgetOneData();
        setSelectedWidgetOne(widget);
        closeModal();
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!!!");
    }
  };

  console.log("selectedWidgetOne: ", selectedWidgetOne);

  return (
    <>
      <div className="grand-chart-div chart-div-style">
        {!selectedWidgetOne && <Loader />}
        <div className="calendar-wrapper-mc">
          {/* <div className="chart-head-left">
            <h3 className="grantt-title">
              {selectedWidgetOne?.name?.toUpperCase()}
            </h3>
          </div> */}

          <div className="calendar-header-mc">
            {/* <div className="head-right-1 d-none">
              <button className="f-btn">New Features</button>
              <button className="f-btn">Select User</button>
            </div> */}
            <h3 class="chart-title-mc">{selectedWidgetOne?.name?.toUpperCase()}</h3>

            <i
              className="fa-regular fa-pen-to-square edit-icon-mc"
              onClick={openModal}
            ></i>
          </div>
        </div>

        <div className="sinter-matchine-row d-none">
          <div className="sinter-matchine-card">
            <div className="sinter-matchine-icon">
              <i className="fa-solid fa-check"></i>
            </div>
            <p className="sinter-matchine-title">
              Sinter machine complex - <span>#Task 1</span>
            </p>
          </div>

          <div className="sinter-matchine-card">
            <div className="sinter-matchine-icon">
              <i className="fa-solid fa-check"></i>
            </div>
            <p className="sinter-matchine-title">
              Replacing thermometer - <span>#221455</span>
            </p>
          </div>

          <div className="sinter-matchine-card">
            <div className="sinter-matchine-icon">
              <i className="fa-solid fa-check"></i>
            </div>
            <p className="sinter-matchine-title">
              Sinter machine complex - <span>#Task 2</span>
            </p>
          </div>

          <div className="sinter-matchine-card">
            <div className="sinter-matchine-icon">
              <i className="fa-solid fa-check"></i>
            </div>
            <p className="sinter-matchine-title">
              Sinter machine complex - <span>#Task 3</span>
            </p>
          </div>

          <div className="sinter-matchine-card">
            <div className="sinter-matchine-icon">
              <i className="fa-solid fa-check"></i>
            </div>
            <p className="sinter-matchine-title">
              Sinter machine complex - <span>#Task 4</span>
            </p>
          </div>

          <div className="sinter-matchine-card">
            <div className="sinter-matchine-icon">
              <i className="fa-solid fa-check"></i>
            </div>
            <p className="sinter-matchine-title">
              Sinter machine complex - <span>#Task 5</span>
            </p>
          </div>
        </div>

        {/* <FBChart1 /> */}
        {selectedWidgetOne?.name === "Gantt Chart" && <GanttChart />}
        {selectedWidgetOne?.name === "Event calender" && <EventsCalender />}
        {selectedWidgetOne?.name === "Investment Manager" && (
          <ViewCapitalOption />
        )}
        {selectedWidgetOne?.name === "Kanban Board Analytics" && (
          <EventsCalender />
        )}
        {console.log("selectedWidgetOne1", selectedWidgetOne)}
        {selectedWidgetOne?.name === "Open Account Receivable" && (
          <DashboardManager />
        )}
        {selectedWidgetOne?.name === "Risk Management" && <RiskManagement />}
        {selectedWidgetOne?.name === "profit vs expense (line graph)" && (
          <DashboardManager />
        )}
        {selectedWidgetOne?.name === "profit vs expense (pie graph)" && (
          <DashboardManager />
        )}
        {selectedWidgetOne?.name === "Expense Bar Chart" && (
          <DashboardManager />
        )}
        {selectedWidgetOne?.name === "Expense Line Chart" && (
          <DashboardManager />
        )}
        {selectedWidgetOne?.name === "Profit Line Chart" && (
          <DashboardManager />
        )}
        {selectedWidgetOne?.name === "Sales Line Chart" && <DashboardManager />}

        {selectedWidgetOne?.name === "Task Completion Status" && (
          <RiskManagement
            taskCompleteStatus={taskCompletionStatus}
            taskAtRisk={taskAtRisk}
            taskDeviationAnalysis={taskDeviationAnalysis}
          />
        )}
        {selectedWidgetOne?.name === "Task Deviation Analysis" && (
          <RiskManagement
            taskCompleteStatus={taskCompletionStatus}
            taskAtRisk={taskAtRisk}
            taskDeviationAnalysis={taskDeviationAnalysis}
          />
        )}
        {selectedWidgetOne?.name === "Tasks At-Risk" && (
          <RiskManagement
            taskCompleteStatus={taskCompletionStatus}
            taskAtRisk={taskAtRisk}
            taskDeviationAnalysis={taskDeviationAnalysis}
          />
        )}
        {selectedWidgetOne?.name === "current total (bar graph)" && (
          <DashboardManager />
        )}
        {selectedWidgetOne?.name === "current total (line graph)" && (
          <DashboardManager />
        )}
        {selectedWidgetOne?.name === "current actual vs budget (bar graph)" && (
          <DashboardManager />
        )}
        {selectedWidgetOne?.name ===
          "current actual vs budget (line graph)" && <DashboardManager />}

        {selectedWidgetOne?.name === "Balance dashboard" && (
          <DashboardManager />
        )}
        {selectedWidgetOne?.name === "Transaction dashboard" && (
          <DashboardManager />
        )}
        {selectedWidgetOne?.name === "Tax deductible (pie graph)" && (
          <DashboardManager />
        )}
        {selectedWidgetOne?.name === "Tax deductible (line graph)" && (
          <DashboardManager />
        )}
      </div>

      {/* MODAL */}
      {isModalOpen && (
        <div className="gd-modal-overlay" onClick={closeModal}>
          <div
            className="gd-modal-panel chart-div-style"
            onClick={(e) => e.stopPropagation()} // prevent overlay close
          >
            <h3 className="gd-modal-title">
              {language?.add_new_dashboard?.toUpperCase()}
            </h3>

            <div className="gd-modal-list d-none">
              <button className="gd-modal-row">
                <span>Kanban Board Analytics</span>
                <span className="gd-modal-plus-btn">
                  <i className="fa-solid fa-plus"></i>
                </span>
              </button>

              <button className="gd-modal-row">
                <span>Gantt Chart</span>
                <span className="gd-modal-plus-btn">
                  <i className="fa-solid fa-plus"></i>
                </span>
              </button>

              <button className="gd-modal-row">
                <span>Risk Management</span>
                <span className="gd-modal-plus-btn">
                  <i className="fa-solid fa-plus"></i>
                </span>
              </button>

              <button className="gd-modal-row">
                <span>Progress Chart</span>
                <span className="gd-modal-plus-btn">
                  <i className="fa-solid fa-plus"></i>
                </span>
              </button>

              <button className="gd-modal-row">
                <span>Forecasting</span>
                <span className="gd-modal-plus-btn">
                  <i className="fa-solid fa-plus"></i>
                </span>
              </button>

              <button className="gd-modal-row">
                <span>View all balance</span>
                <span className="gd-modal-plus-btn">
                  <i className="fa-solid fa-plus"></i>
                </span>
              </button>

              <button className="gd-modal-row">
                <span>Event calender</span>
                <span className="gd-modal-plus-btn">
                  <i className="fa-solid fa-plus"></i>
                </span>
              </button>

              <button className="gd-modal-row">
                <span>Investment Manager</span>
                <span className="gd-modal-plus-btn">
                  <i className="fa-solid fa-plus"></i>
                </span>
              </button>
            </div>

            <div className="gd-modal-list">
              {widgetsOne?.length > 0 ? (
                widgetsOne?.map((widget) => (
                  <button
                    disabled={widget?.visible}
                    style={{
                      opacity: widget?.visible ? 0.3 : 1,
                      cursor: widget?.visible ? "not-allowed" : "pointer",
                    }}
                    className="gd-modal-row"
                    key={widget?.id}
                    onClick={() => handleAddWidget(widget)}
                  >
                    <span>{widget?.name?.toUpperCase()}</span>
                    <span
                      style={{
                        opacity: widget?.visible ? 0.3 : 1,
                        cursor: widget?.visible ? "not-allowed" : "pointer",
                      }}
                      className="gd-modal-plus-btn"
                    >
                      <i className="fa-solid fa-plus"></i>
                    </span>
                  </button>
                ))
              ) : (
                <div className="gd-modal-row">
                  <span>No Widget Found ...</span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GrandChart;
